import { AuthProvider, PlacesLoader } from '@/loaders'
import { store as defaultStore } from '@/redux/store/initStore'
import { StytchB2BProvider } from '@stytch/react/b2b'
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b'
import { SnackbarProvider } from 'notistack'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { TanStackQueryProvider } from './TanStackQuery'
import { ThemeProvider } from './Theme'

import type { FC, PropsWithChildren, ReactElement } from 'react'

interface PropsWithStore extends PropsWithChildren {
	store?: typeof defaultStore
}

// Create the Stytch client once at module scope to avoid multiple instances
const stytchClient = new StytchB2BUIClient(import.meta.env.VITE_STYTCH_PUBLIC_TOKEN as string)

export const AppProvider: FC<PropsWithStore> = ({ children, store = defaultStore }) => {
	return (
		<Provider store={store}>
			<BrowserRouter>
				<StytchB2BProvider stytch={stytchClient}>
					<AuthProvider>
						<TanStackQueryProvider>
							<PlacesLoader>
								<ThemeProvider>
									<SnackbarProvider maxSnack={3}>{children}</SnackbarProvider>
								</ThemeProvider>
							</PlacesLoader>
						</TanStackQueryProvider>
					</AuthProvider>
				</StytchB2BProvider>
			</BrowserRouter>
		</Provider>
	) as ReactElement<any, any>
}
